// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"537178c6","408":"03b318d2","453":"d7446e4a"}[chunkId] + ".chunk.js";
};